import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_42bab598 from 'nuxt_plugin_plugin_42bab598' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_workbox_568eec48 from 'nuxt_plugin_workbox_568eec48' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_nuxticons_8f2d5ac8 from 'nuxt_plugin_nuxticons_8f2d5ac8' // Source: ./nuxt-icons.js (mode: 'all')
import nuxt_plugin_pluginseo_e3e776ba from 'nuxt_plugin_pluginseo_e3e776ba' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_2a159f1a from 'nuxt_plugin_pluginrouting_2a159f1a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_21e99ad6 from 'nuxt_plugin_pluginmain_21e99ad6' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_libmoduleplugincdaecc3c_6160fff5 from 'nuxt_plugin_libmoduleplugincdaecc3c_6160fff5' // Source: ./lib.module.plugin.cdaecc3c.js (mode: 'all')
import nuxt_plugin_axios_2e0a522c from 'nuxt_plugin_axios_2e0a522c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_passwordprotect_5b346def from 'nuxt_plugin_passwordprotect_5b346def' // Source: ./password-protect.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_d55bcc58 from 'nuxt_plugin_cookieuniversalnuxt_d55bcc58' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_localize_3b6c534e from 'nuxt_plugin_localize_3b6c534e' // Source: ../plugins/localize.ts (mode: 'all')
import nuxt_plugin_components_50cb0ca1 from 'nuxt_plugin_components_50cb0ca1' // Source: ../plugins/components.ts (mode: 'all')
import nuxt_plugin_gtag_0a2caf78 from 'nuxt_plugin_gtag_0a2caf78' // Source: ../plugins/gtag.ts (mode: 'client')
import nuxt_plugin_cookieconsentclient_fe4f56d8 from 'nuxt_plugin_cookieconsentclient_fe4f56d8' // Source: ../plugins/cookieconsent.client.ts (mode: 'client')
import nuxt_plugin_vuecarousel_e4202c60 from 'nuxt_plugin_vuecarousel_e4202c60' // Source: ../plugins/vue-carousel.ts (mode: 'client')
import nuxt_plugin_vuejsonviewer_59649653 from 'nuxt_plugin_vuejsonviewer_59649653' // Source: ../plugins/vue-json-viewer.ts (mode: 'client')
import nuxt_plugin_vuevideo_9f1688a2 from 'nuxt_plugin_vuevideo_9f1688a2' // Source: ../plugins/vue-video.ts (mode: 'client')
import nuxt_plugin_vuexpersist_25bda8c4 from 'nuxt_plugin_vuexpersist_25bda8c4' // Source: ../plugins/vuex-persist.ts (mode: 'client')
import nuxt_plugin_veevalidate_1a0c172c from 'nuxt_plugin_veevalidate_1a0c172c' // Source: ../plugins/vee-validate.ts (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp (ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  const registerModule = store.registerModule
  store.registerModule = (path, rawModule, options) => registerModule.call(store, path, rawModule, Object.assign({ preserveState: process.client }, options))

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"idioma","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Findestructibletype.com\u002Ffonts\u002FJost.css"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.d555304f.json"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_plugin_42bab598 === 'function') {
    await nuxt_plugin_plugin_42bab598(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_568eec48 === 'function') {
    await nuxt_plugin_workbox_568eec48(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxticons_8f2d5ac8 === 'function') {
    await nuxt_plugin_nuxticons_8f2d5ac8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_e3e776ba === 'function') {
    await nuxt_plugin_pluginseo_e3e776ba(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_2a159f1a === 'function') {
    await nuxt_plugin_pluginrouting_2a159f1a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_21e99ad6 === 'function') {
    await nuxt_plugin_pluginmain_21e99ad6(app.context, inject)
  }

  if (typeof nuxt_plugin_libmoduleplugincdaecc3c_6160fff5 === 'function') {
    await nuxt_plugin_libmoduleplugincdaecc3c_6160fff5(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2e0a522c === 'function') {
    await nuxt_plugin_axios_2e0a522c(app.context, inject)
  }

  if (typeof nuxt_plugin_passwordprotect_5b346def === 'function') {
    await nuxt_plugin_passwordprotect_5b346def(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_d55bcc58 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_d55bcc58(app.context, inject)
  }

  if (typeof nuxt_plugin_localize_3b6c534e === 'function') {
    await nuxt_plugin_localize_3b6c534e(app.context, inject)
  }

  if (typeof nuxt_plugin_components_50cb0ca1 === 'function') {
    await nuxt_plugin_components_50cb0ca1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_0a2caf78 === 'function') {
    await nuxt_plugin_gtag_0a2caf78(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cookieconsentclient_fe4f56d8 === 'function') {
    await nuxt_plugin_cookieconsentclient_fe4f56d8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecarousel_e4202c60 === 'function') {
    await nuxt_plugin_vuecarousel_e4202c60(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuejsonviewer_59649653 === 'function') {
    await nuxt_plugin_vuejsonviewer_59649653(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuevideo_9f1688a2 === 'function') {
    await nuxt_plugin_vuevideo_9f1688a2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersist_25bda8c4 === 'function') {
    await nuxt_plugin_vuexpersist_25bda8c4(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_1a0c172c === 'function') {
    await nuxt_plugin_veevalidate_1a0c172c(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
